import * as types from './index';

export const loginUserAction = (data) => {
    return {
    type: types.LOGIN_USER,
    data
    }
};

export const logoutUserAction = (data) =>{
    return {
        type: types.LOGOUT_USER,
        data
    }
}

export const emailVerifyAction = (data) =>{
    return {
        type: types.EMAIL_VERIFICATION,
        data
    }
}

export const setPasswordAction = (data) =>{
    return {
        type: types.SET_PASSWORD,
        data
    }
}

export const loginClientAffiliateListAction =(data) =>{
    return {
        type: types.LOGIN_CLIENT_AFFILIATE_LIST,
        data
    }
}

export const forgotPasswordAction = (data) =>{
    return {
        type: types.FORGOT_PASSWORD,
        data
    }
}

export const resetPasswordVerifyAction = (data) =>{
    return {
        type: types.RESET_PASSWORD_VERIFICATION,
        data
    }
}

export const refreshTokenAction = (data) =>{
    return {
        type: types.REFRESH_TOKEN,
        data
    }
}

